import classNames from 'classnames';
import {
  FlexContainer,
  LoadingPlaceholder,
  PartialWidthContainer,
  Tabs,
} from 'components';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import { useNotices } from 'state';
import styles from './NoticesLayout.module.scss';

const tabsOptions = [
  {
    key: 'admin',
    path: 'admin',
    value: 'Admin',
  },
  {
    key: 'payments',
    path: 'payments',
    value: 'Payments',
  },
  {
    key: 'messaging',
    path: 'messaging',
    value: 'Messaging',
  },
];

/**
 * NoticesLayout
 *
 * @return {JSX.Element}
 */
const NoticesLayout = () => {
  const noticesCollection = useNotices();

  return noticesCollection.isInitialized ? (
    <PartialWidthContainer
      className={classNames(styles.NoticesLayout)}
      gap
      small
    >
      <Helmet title="Notices" />
      <Tabs className={styles.Header} options={tabsOptions} asNav />
      <FlexContainer className={styles.Body} column>
        <Outlet />
      </FlexContainer>
    </PartialWidthContainer>
  ) : (
    <LoadingPlaceholder />
  );
};

NoticesLayout.displayName = 'NoticesLayout';

export default observer(NoticesLayout);
